import { NavLink, useLocation } from 'react-router-dom';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

export default function SidebarNavItem({ label, icon, to, exact = false, onClick, sx }) {
  const location = useLocation();
  const current = `${location.pathname}${location.search || ''}`;
  const isActive = exact
    ? (current === to || (to.includes('?section=home') && current === to.split('?')[0]))
    : current.startsWith(to);

  return (
    <ListItemButton
      component={NavLink}
      to={to}
      selected={isActive}
      onClick={onClick}
      sx={{
        borderRadius: 0,
        '&.Mui-selected': {
          bgcolor: 'rgba(255,255,255,0.15)',
          borderLeft: '4px solid #fff',
        },
        '&.Mui-selected:hover': {
          bgcolor: 'rgba(255,255,255,0.22)',
        },
        ...sx,
      }}
    >
      {icon && (
        <ListItemIcon sx={{ minWidth: 40, color: 'inherit' }}>
          {icon}
        </ListItemIcon>
      )}
      <ListItemText primary={label} />
    </ListItemButton>
  );
}
